import OverViewIcon from "../Icons/OverViewIcon";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import UsersIcon from "../Icons/UsersIcon";
import RoleIcon from "../Icons/RoleIcon";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";
import CalendarIcon from "../Icons/CalendarIcon";

export const shouldShowWelcome = getKey("shouldShowWelcome");

export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      ...(shouldShowWelcome === "true" || shouldShowWelcome === null
        ? [
            {
              name: "Welcome",
              href: "/user-role",
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: "Overview",
              href: "/user-role/overview",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: "Overview",
              href: "/user-role",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: "Users and Roles",
    href: "",
    icon: "",
    children: [
      {
        name: "Users",
        href: "/user-role/users",
        icon: UsersIcon,
        activeIcon: UsersIcon,
      },
      {
        name: "Roles",
        href: "/user-role/roles",
        icon: RoleIcon,
        activeIcon: RoleIcon,
      },
    ],
  },
  {
    name: "Fiscal Management",
    href: "",
    icon: "",
    children: [
      {
        name: "Fiscal Year",
        href: "/user-role/fiscal-year",
        icon: CalendarIcon,
        activeIcon: CalendarIcon,
      },
    ],
  },
  {
    name: "Branch Management",
    href: "",
    icon: "",
    children: [
      {
        name: "Branch",
        href: "/user-role/branch",
        icon: WelcomeIcon,
        activeIcon: WelcomeIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 overflow-y-auto h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
